import { userManagementApis } from "@services/apis/UserManagement";
import { GetKycResponseData } from "@services/models/UserManagement/get-kyc";
import { useEffect, useState } from "react";
import KybDetails from "./kyc-kyb/kyb-details";
import KycDetails from "./kyc-kyb/kyc-details";
import KycDetailsSkeleton from "./kyc-kyb/kyc-skeleton-loader";

const Kyckyb = ({
  userId,
  accountType,
}: {
  userId: number;
  accountType: string;
}) => {
  const [kycData, setKycData] = useState<GetKycResponseData>();
  const [isKycLoading, setIsKycLoading] = useState(false);
  const [isKybLoading, setIsKybLoading] = useState(false);
  const [kybId, setKybId] = useState<string>("");

  const isIndividualAccount =
    accountType === "individual" ||
    accountType === "affiliate" ||
    accountType === "cashier";

  const getKycData = async () => {
    setIsKycLoading(true);
    try {
      const response = await userManagementApis.getKycDetails({
        userId: userId,
      });

      setKycData(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsKycLoading(false);
    }
  };

  const getKybData = async () => {
    setIsKybLoading(true);

    try {
      const response = await userManagementApis.getKybDetails(userId);

      setKybId(response.data!.id || "");
    } catch (error) {
      console.error(error);
    } finally {
      setIsKybLoading(false);
    }
  };

  useEffect(() => {
    if (isIndividualAccount) {
      getKycData();
    } else {
      getKybData();
    }
  }, [userId, accountType]);

  return (
    <div className="p-[16px] rounded-lg border border-border-subtle bg-bg-base mt-[16px] flex flex-col">
      {/* KYC FLOW */}
      {isIndividualAccount && (
        <>
          {isKycLoading && <KycDetailsSkeleton />}

          {!isKycLoading && kycData && (
            <KycDetails data={kycData} onRefresh={getKycData} />
          )}
        </>
      )}

      {/* KYB FLOW */}
      {!isIndividualAccount && (
        <>
          {isKybLoading && <KycDetailsSkeleton />}

          {!isKybLoading && kybId && <KybDetails id={kybId} />}
        </>
      )}
    </div>
  );
};

export default Kyckyb;
